const PICK_ANSWER = 'pickAnswer'
const FREESTYLE = 'freestyle'
const TYPE_ANSWER = 'typeAnswer'

export default {
  PICK_ANSWER,
  FREESTYLE,
  TYPE_ANSWER,
}
